let CryptoJS = require('crypto-js');
let retrieveSecret = require('./retrieveSecrets');

export async function localStorageEncrypt(localStorageValues) {
    let encryptedValues;
    try {
        const retrievedSecret = await retrieveSecret();

        encryptedValues = CryptoJS.AES.encrypt(localStorageValues, retrievedSecret).toString();

        console.log('AES Enc Key', JSON.stringify(encryptedValues));
        return encryptedValues;
    } catch (err) {
        console.log('Encryption ERROR:', err.message);
    }

}